import SuccessIcon from './success.svg';
import WarningIcon from './warning.svg';
import ErrorIcon from './error.svg';
import InfoIcon from './info.svg';

export const icons = {
	success: SuccessIcon,
	warning: WarningIcon,
	error: ErrorIcon,
	info: InfoIcon,
};
